export default "__VITE_ASSET__b876923c__"